import { apiClient } from '@/lib/api/client';
import type { ApiResponse } from '@/lib/types';
import type { SignupData, AuthResponse, ForgotPasswordData } from '../types/auth.types';

export const authService = {
  async signup(data: SignupData): Promise<ApiResponse<AuthResponse>> {
    const response = await apiClient.post('/seller/create', data);
    return response.data;
  },

  async forgotPassword(data: ForgotPasswordData): Promise<ApiResponse<{ message: string }>> {
    const response = await apiClient.post('/auth/seller/forgetPassword', data);
    return response.data;
  },

  async resetPassword(token: string, password: string): Promise<ApiResponse<{ message: string }>> {
    // Le serveur attend le token comme Bearer token dans le header Authorization
    const response = await apiClient.post(
      '/auth/seller/forgetPassword/change',
      { password },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },

  async resendActivationEmail(email: string): Promise<ApiResponse<{ message: string }>> {
    const response = await apiClient.post('/auth/seller/resend-activation', { email });
    return response.data;
  },
};
